import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import ItemCard from './ItemCard';
import {
  getItemSelectionInfo,
  resetItemSelectionState,
  updateItemSelectionInfo,
} from './itemSelectionSlice';
import { itemSelectionOptions } from '../../../common/data';
import { magamCertifyCheck } from '../../../common/Util';

const ItemListSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/itemSelection');
  const { isMagam, isCertify } = useSelector(state => state.common);
  const { dataList, isRender, reload, nonItemList } = useSelector(state => state.itemSelection);
  const options = itemSelectionOptions(t);

  useEffect(() => {
    dispatch(getItemSelectionInfo());
  }, []);

  //저장, 삭제시 재호출
  useEffect(() => {
    if (reload != -1) {
      dispatch(getItemSelectionInfo());
    }
  }, [reload]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetItemSelectionState());
    };
  }, [dispatch]);

  const handleChange = (index, key, value) => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    dispatch(
      updateItemSelectionInfo({
        htm001: dataList[index].htm001,
        m_id: key,
        m_value: value,
      }),
    );
    // if (isValidate) {

    // }
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      {dataList.map((data, index) => {
        const hiddenKeys = nonItemList[index] || [];

        const filteredOptions = options.filter(option => !hiddenKeys.includes(option.key));
        const isDisabledList = options.filter(option => hiddenKeys.includes(option.key));

        return (
          <ItemCard
            data={data}
            key={index}
            handleChange={handleChange}
            selectedIndex={index}
            filteredOptions={filteredOptions}
            isDisabledList={isDisabledList}
          />
        );
      })}
    </div>
  );
};

export default ItemListSection;
